import { usePage } from '@inertiajs/react'
import type { SharedPageProps } from '@/types'

export function usePermissions() {
  const { props } = usePage<SharedPageProps>()
  const permissions = props.currentUser?.permissions || []

  const can = (permission: string): boolean => {
    if (permissions.includes('All:all')) return true
    if (permissions.includes(permission)) return true
    const scope = permission.split(':').slice(0, -1).join(':')
    return permissions.includes(`${scope}:all`)
  }

  return { can, permissions }
}
